const getData = (source) => {
  let data = [];

  switch (source) {
    case "leads":
      data = [
        {
          id: 1,
          birthday: "1964-08-24T12:00:20+02:00",
          first_name: "תשבי",
          gender_id: 2,
          surename: "תרצה",
          lead_owner_id: 12,
          lead_status_id: 1,
          lead_source_id: 2,
          created_by_id: 12,
          lead_owner: {
            name: "ארנון אלחנני",
          },
          assigned_to: {
            name: "ארנון אלחנני",
          },
          assigned_to_id: 12,
          created_at: "2022-11-28T09:56:23.714553+02:00",
          updated_at: "2022-11-28T09:56:23.714553+02:00",
          address: {
            apartment_number: "",
            city: "אשקלון",
            house_number: "0",
            postal_code: "",
            street: "תירוש",
          },
          contact_info: {
            agree_to_receive_email: null,
            email: "cguise0@businesswire.com",
            fax_number: null,
            mailbox_number: "",
            mobile_number: "+972529867307",
            phone_number: "+972523166827",
          },
        },
        {
          id: 2,
          birthday: "1964-08-24T12:00:20+02:00",
          first_name: "אלי",
          gender_id: 1,
          surename: "ישראלי",
          lead_owner_id: 12,
          lead_status_id: 1,
          lead_source_id: 2,
          created_by_id: 12,
          lead_owner: {
            name: "ארנון אלחנני",
          },
          assigned_to: {
            name: "ארנון אלחנני",
          },
          assigned_to_id: 12,
          created_at: "2022-11-28T09:56:23.714553+02:00",
          updated_at: "2022-11-28T09:56:23.714553+02:00",
          address: {
            apartment_number: "3",
            city: "תל אביב",
            house_number: "3",
            postal_code: "",
            street: "הבונים",
          },
          contact_info: {
            agree_to_receive_email: null,
            email: "abrahan@ffg.com",
            fax_number: null,
            mailbox_number: "",
            mobile_number: "+972553453455",
            phone_number: "+972534655345",
          },
        },
        {
          id: 3,
          birthday: "1964-08-24T12:00:20+02:00",
          first_name: "סיון",
          gender_id: 2,
          surename: "מאיר",
          lead_owner_id: 12,
          lead_status_id: 2,
          lead_source_id: 2,
          created_by_id: 12,
          lead_owner: {
            name: "ארנון אלחנני",
          },
          assigned_to: {
            name: "ארנון אלחנני",
          },
          assigned_to_id: 12,
          created_at: "2022-11-28T09:56:23.714553+02:00",
          updated_at: "2022-11-28T09:56:23.714553+02:00",
          address: {
            apartment_number: "2",
            city: "חדרה",
            house_number: "44",
            postal_code: "",
            street: "העצמאות",
          },
          contact_info: {
            agree_to_receive_email: null,
            email: "ffdff@gmail.com",
            fax_number: null,
            mailbox_number: "",
            mobile_number: "+972543534534",
            phone_number: "+972522343244",
          },
        },
      ];
      break;
    case "opportunities":
      data = [
        {
          id: 1,
          birthday: "1964-08-24T12:00:20+02:00",
          first_name: "תשבי",
          gender_id: 2,
          surename: "תרצה",
          lead_owner_id: 12,
          lead_status_id: 1,
          lead_source_id: 2,
          created_by_id: 12,
          lead_owner: {
            name: "ארנון אלחנני",
          },
          assigned_to: {
            name: "ארנון אלחנני",
          },
          assigned_to_id: 12,
          created_at: "2022-11-28T09:56:23.714553+02:00",
          updated_at: "2022-11-28T09:56:23.714553+02:00",
          address: {
            apartment_number: "",
            city: "אשקלון",
            house_number: "0",
            postal_code: "",
            street: "תירוש",
          },
          contact_info: {
            agree_to_receive_email: null,
            email: "cguise0@businesswire.com",
            fax_number: null,
            mailbox_number: "",
            mobile_number: "+972529867307",
            phone_number: "+972523166827",
          },
        },
        {
          id: 2,
          birthday: "1964-08-24T12:00:20+02:00",
          first_name: "אלי",
          gender_id: 1,
          surename: "ישראלי",
          lead_owner_id: 12,
          lead_status_id: 1,
          lead_source_id: 2,
          created_by_id: 12,
          lead_owner: {
            name: "ארנון אלחנני",
          },
          assigned_to: {
            name: "ארנון אלחנני",
          },
          assigned_to_id: 12,
          created_at: "2022-11-28T09:56:23.714553+02:00",
          updated_at: "2022-11-28T09:56:23.714553+02:00",
          address: {
            apartment_number: "3",
            city: "תל אביב",
            house_number: "3",
            postal_code: "",
            street: "הבונים",
          },
          contact_info: {
            agree_to_receive_email: null,
            email: "abrahan@ffg.com",
            fax_number: null,
            mailbox_number: "",
            mobile_number: "+972553453455",
            phone_number: "+972534655345",
          },
        },
        {
          id: 3,
          birthday: "1964-08-24T12:00:20+02:00",
          first_name: "סיון",
          gender_id: 2,
          surename: "מאיר",
          lead_owner_id: 12,
          lead_status_id: 2,
          lead_source_id: 2,
          created_by_id: 12,
          lead_owner: {
            name: "ארנון אלחנני",
          },
          assigned_to: {
            name: "ארנון אלחנני",
          },
          assigned_to_id: 12,
          created_at: "2022-11-28T09:56:23.714553+02:00",
          updated_at: "2022-11-28T09:56:23.714553+02:00",
          address: {
            apartment_number: "2",
            city: "חדרה",
            house_number: "44",
            postal_code: "",
            street: "העצמאות",
          },
          contact_info: {
            agree_to_receive_email: null,
            email: "ffdff@gmail.com",
            fax_number: null,
            mailbox_number: "",
            mobile_number: "+972543534534",
            phone_number: "+972522343244",
          },
        },
      ];
      break;

    case "contacts":
      data = [
        {
          id: 1,
          birthday: "1964-08-24T12:00:20+02:00",
          first_name: "תשבי",
          gender_id: 2,
          surename: "תרצה",
          lead_owner_id: 12,
          lead_status_id: 1,
          lead_source_id: 2,
          created_by_id: 12,
          lead_owner: {
            name: "ארנון אלחנני",
          },
          assigned_to: {
            name: "ארנון אלחנני",
          },
          assigned_to_id: 12,
          created_at: "2022-11-28T09:56:23.714553+02:00",
          updated_at: "2022-11-28T09:56:23.714553+02:00",
          address: {
            apartment_number: "",
            city: "אשקלון",
            house_number: "0",
            postal_code: "",
            street: "תירוש",
          },
          contact_info: {
            agree_to_receive_email: null,
            email: "cguise0@businesswire.com",
            fax_number: null,
            mailbox_number: "",
            mobile_number: "+972529867307",
            phone_number: "+972523166827",
          },
        },
        {
          id: 2,
          birthday: "1964-08-24T12:00:20+02:00",
          first_name: "אלי",
          gender_id: 1,
          surename: "ישראלי",
          lead_owner_id: 12,
          lead_status_id: 1,
          lead_source_id: 2,
          created_by_id: 12,
          lead_owner: {
            name: "ארנון אלחנני",
          },
          assigned_to: {
            name: "ארנון אלחנני",
          },
          assigned_to_id: 12,
          created_at: "2022-11-28T09:56:23.714553+02:00",
          updated_at: "2022-11-28T09:56:23.714553+02:00",
          address: {
            apartment_number: "3",
            city: "תל אביב",
            house_number: "3",
            postal_code: "",
            street: "הבונים",
          },
          contact_info: {
            agree_to_receive_email: null,
            email: "abrahan@ffg.com",
            fax_number: null,
            mailbox_number: "",
            mobile_number: "+972553453455",
            phone_number: "+972534655345",
          },
        },
        {
          id: 3,
          birthday: "1964-08-24T12:00:20+02:00",
          first_name: "סיון",
          gender_id: 2,
          surename: "מאיר",
          lead_owner_id: 12,
          lead_status_id: 2,
          lead_source_id: 2,
          created_by_id: 12,
          lead_owner: {
            name: "ארנון אלחנני",
          },
          assigned_to: {
            name: "ארנון אלחנני",
          },
          assigned_to_id: 12,
          created_at: "2022-11-28T09:56:23.714553+02:00",
          updated_at: "2022-11-28T09:56:23.714553+02:00",
          address: {
            apartment_number: "2",
            city: "חדרה",
            house_number: "44",
            postal_code: "",
            street: "העצמאות",
          },
          contact_info: {
            agree_to_receive_email: null,
            email: "ffdff@gmail.com",
            fax_number: null,
            mailbox_number: "",
            mobile_number: "+972543534534",
            phone_number: "+972522343244",
          },
        },
      ];
      break;

    case "campaigns":
      data = [
        {
          id: 1,
          name: "לידים דרך קמפיין פייסבוק",
          create_date: "1964-08-24T12:00:20+02:00",
          start_date: "2021-08-24T12:00:20+02:00",
          end_date: "2022-03-24T12:00:20+02:00",
          campaign_owner_id: 12,
          campagin_owner: {
            name: "ארנון אלחנני",
          },
          status_id: 12,
          status: {
            name: "בתהליך",
          },
          type_id: 12,
          type: {
            name: "רשתות חברתיות",
          },
          active: true,
          description:
            "קמפיין בפייסבוק שנועד לפנות לפלח של כאלו המחפשים מעונות יום או טיפול סיעודי",
        },
      ];
      break;

    case "tasks":
      data = [
        {
          id: 1,
          name: "להתקשר להורים של יוסי ולתאם פגישה",
          relation: {
            name: "יוסי ישראלי",
          },
          status: {
            name: "פתוח",
          },
          due_date: "2023-01-11T09:56:23.714553+02:00",
        },
        {
          id: 2,
          name: "לעדכן את אלי שהוא זכאי לגמלה",
          relation: {
            name: "אלי אברהמי",
          },
          status: {
            name: "פתוח",
          },
          due_date: "2023-01-13T11:56:23.714553+02:00",
        },
        {
          id: 3,
          name: "להתקשר לבת של אסתר ולומר לה להביא מסמכים",
          relation: {
            name: "אסתר יצחקוב",
          },
          status: {
            name: "פתוח",
          },
          due_date: "2023-01-10T19:56:23.714553+02:00",
        },
        {
          id: 4,
          name: "לבדוק סטטוס של יצחק והאם המצב שלא הוחמר",
          relation: {
            name: "יצחק באום",
          },
          status: {
            name: "פתוח",
          },
          due_date: "2023-01-15T19:56:23.714553+02:00",
        },
        {
          id: 5,
          name: "להתקשר ולבדוק אם המסמכים של בטי הגיעו",
          relation: {
            name: "בטי גרשנוביץ",
          },
          status: {
            name: "פתוח",
          },
          due_date: "2023-01-10T19:56:23.714553+02:00",
        },
        {
          id: 6,
          name: "לבדוק האם גם הבעל זקוק לעזרה סיעודית",
          relation: {
            name: "אסתר מסיקה",
          },
          status: {
            name: "פתוח",
          },
          due_date: "2023-01-19T19:56:23.714553+02:00",
        },
      ];
      break;

    default:
      data = [];
      break;
  }
  return data;
};

export { getData };
